<template>
  <div class="records">
    <van-nav-bar title="盘点记录" left-arrow @click-left="$router.back()" />

    <div class="record-list">
      <div class="record-card" v-for="item in records" :key="item.no">
        <div class="record-header">
          <span class="record-vid">{{ item.vid }}</span>
          <van-tag :type="item.status === '正常' ? 'success' : 'warning'">
            {{ item.status || '未知' }}
          </van-tag>
        </div>
        <div class="record-body">
          <div class="record-info">
            <span class="label">车辆：</span>
            <span>{{ item.vehicleBand }} {{ item.vehicleModel }}</span>
          </div>
          <div class="record-info">
            <span class="label">公司：</span>
            <span>{{ item.ownerCompany || '未知' }}</span>
          </div>
          <div class="record-info">
            <span class="label">盘点人：</span>
            <span>{{ item.checker }}</span>
          </div>
          <div class="record-info">
            <span class="label">盘点时间：</span>
            <span>{{ item.checkTime }}</span>
          </div>
          <div class="record-info" v-if="item.remark">
            <span class="label">备注：</span>
            <span>{{ item.remark }}</span>
          </div>
        </div>
        <div class="record-footer" v-if="item.videoPath">
          <div class="video-link" @click="playVideo(item.videoPath)">
            查看盘点视频
          </div>
        </div>
      </div>

      <div v-if="!loading && records.length === 0" class="empty-tip">
        暂无盘点记录
      </div>
    </div>

    <!-- 视频预览弹窗 -->
    <van-overlay :show="showVideo" @click="showVideo = false">
      <div class="video-container">
        <video
          ref="videoPlayer"
          :src="videoUrl"
          controls
          autoplay
          class="video-player"
        ></video>
        <div class="video-close" @click="showVideo = false">关闭</div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import http from "../utils/http";

export default {
  name: "InventoryRecords",
  data() {
    return {
      records: [],
      loading: false,
      showVideo: false,
      videoUrl: "",
    };
  },
  created() {
    this.loadRecords();
  },
  methods: {
    async loadRecords() {
      this.loading = true;
      try {
        const res = await http.get("/api/Inventory/GetCheckedRecords");
        if (res.code === 0) {
          this.records = res.data || [];
        }
      } catch (error) {
        console.error("加载记录失败:", error);
      } finally {
        this.loading = false;
      }
    },
    async playVideo(path) {
      // 获取 token
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      // 通过 fetch 获取视频 blob，携带 token
      const url = window.location.origin + path;
      try {
        const response = await fetch(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.ok) {
          const blob = await response.blob();
          this.videoUrl = URL.createObjectURL(blob);
          this.showVideo = true;
        } else {
          console.error("视频加载失败");
        }
      } catch (error) {
        console.error("视频请求失败:", error);
      }
    },
  },
};
</script>

<style scoped>
.records {
  max-width: 512px;
  margin: 0 auto;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.record-list {
  padding: 12px 16px;
}

.record-card {
  background: #fff;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.record-vid {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  word-break: break-all;
}

.record-info {
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
}

.record-info .label {
  color: #999;
}

.record-footer {
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
  margin-top: 8px;
}

.video-link {
  color: #007aff;
  font-size: 14px;
  cursor: pointer;
}

.video-link:active {
  color: #0056b3;
}

.empty-tip {
  text-align: center;
  color: #999;
  padding: 40px;
}

/* 视频预览样式 */
.video-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
}

.video-player {
  max-width: 100%;
  max-height: 80vh;
  background: #000;
}

.video-close {
  margin-top: 16px;
  color: #fff;
  font-size: 16px;
  padding: 10px 30px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  cursor: pointer;
}
</style>
